import { Cpu, Database } from "lucide-react";
import { motion } from "motion/react";
import { useSectionParallax } from "../../../hooks/useSectionParallax";

// Matches the kernel sizes iviz-kernel offers today — no GPU tier exists.
const TIERS = [
  { name: "Standard S", spec: "1 vCPU · 4 GB RAM", use: "Default · instant start", icon: Cpu },
  { name: "Standard M", spec: "2 vCPU · 8 GB RAM", use: "Everyday analysis", icon: Cpu },
  { name: "Standard L", spec: "4 vCPU · 16 GB RAM", use: "Heavier modelling", icon: Cpu },
  { name: "Memory M", spec: "4 vCPU · 30 GB RAM", use: "Large datasets", icon: Database },
  { name: "Memory L", spec: "8 vCPU · 61 GB RAM", use: "Largest datasets", icon: Database },
];

export function ComputeSelector() {
  const { ref, bgY, fgY } = useSectionParallax();
  return (
    <div ref={ref}>
      <motion.div style={{ y: fgY }}>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#1E4FD8] dark:text-[#4A90D9] mb-3 text-center">
          Notebook · Compute
        </p>
        <h3 className="text-3xl font-normal tracking-[-0.02em] text-[#0A0A0F] dark:text-white text-center max-w-2xl mx-auto mb-4">
          Your code shouldn&apos;t be limited by your laptop.
        </h3>
        <p className="text-base leading-[1.7] text-[#5C5C66] dark:text-[#9A9A9A] text-center max-w-xl mx-auto mb-14">
          Every notebook runs in its own isolated cloud container. Small kernels start instantly,
          you can switch size from inside the notebook, and idle kernels shut themselves down.
        </p>
      </motion.div>
      <motion.div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-y-10 lg:divide-x divide-[#0A0A0F]/10 dark:divide-white/10" style={{ y: bgY }}>
        {TIERS.map(({ name, spec, use, icon: Icon }, i) => (
          <div key={name} className={`${i > 0 ? "lg:pl-8" : ""} ${i < TIERS.length - 1 ? "lg:pr-8" : ""}`}>
            <Icon size={18} className="text-[#1E4FD8] dark:text-[#4A90D9] mb-4" />
            <p className="text-xs font-bold uppercase tracking-widest text-[#0A0A0F] dark:text-white mb-2">{name}</p>
            <p className="font-mono text-xs text-[#5C5C66] dark:text-[#9A9A9A] mb-3">{spec}</p>
            <p className="text-sm text-[#5C5C66] dark:text-[#9A9A9A]">{use}</p>
          </div>
        ))}
      </motion.div>
    </div>
  );
}
